import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/styles';
import Button from 'components/base/Button';
import styles from './styles';


const FirstPageLink = ({
  onClick,
  classes,
  hide,
}) => (
  hide ? null : (
    <Button variant="contained" className={classes.root} onClick={onClick} color="secondary" >
      <NavigateBeforeIcon />
    </Button>
  )
);

FirstPageLink.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  onClick: PropTypes.func.isRequired,
  hide: PropTypes.bool,
  styleFirstPageLink: PropTypes.shape({}),
};

FirstPageLink.defaultProps = {
  styleFirstPageLink: {},
  hide: false,
};

export default withStyles(styles)(FirstPageLink);
